import { AppConfigParams } from "@project/core/utils/nextPublicConfigRuntime";

export const appConfigParams: AppConfigParams = {
  owner: "nutri.sapn",
  top_level_domain: "propelhealth.ai",
  dsn: "https://1926191fc2cd4d8791199cbbdc74e4d2@o441878.ingest.sentry.io/6711255",
};
